export const SITE_URL = 'https://www.maphotoentableau.fr';
export const SITE_NAME = 'Ma Photo en Tableau';

export const absoluteUrl = (path = '') => {
  if (!path || path === '/') return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
